<!-- 此component用來Video瀏覽 -->
<template>
  <div id="videovuer" :style="{'text-align': 'center', 'max-width': '1440px', 'margin': '0 auto'}">
    <ScaleOut v-show="loading" class="loading-icon"></ScaleOut>
    <el-button v-show="getDataOk" class="fullscreen-btn" :title="fullscreentitle" @click="toggle">
      <img src="../../assets/icon/ic_fullscreen.png" alt="F" class="fullscreen-icon">
    </el-button>
    <video-player v-if="getDataOk" 
                  class="vvjs-custom-skin"
                  ref="videoPlayer"
                  :options="playerOptions"
                  :playsinline="true"
                  customEventName="customstatechangedeventname"
                  @play="onPlayerPlay($event)"
                  @pause="onPlayerPause($event)"
                  @ended="onPlayerEnded($event)"
                  @waiting="onPlayerWaiting($event)"
                  @playing="onPlayerPlaying($event)"
                  @loadeddata="onPlayerLoadeddata($event)"
                  @timeupdate="onPlayerTimeupdate($event)"
                  @canplay="onPlayerCanplay($event)"
                  @canplaythrough="onPlayerCanplaythrough($event)"
                  @statechanged="playerStateChanged($event)"
                  @ready="playerReadied">
    </video-player>
    <WaterMark v-if="systemAdminMode === false" v-bind:inputText='inputText'></WaterMark>
    <hint v-show="hint.display && this.$store.state.hintStatus.videoView" :message="hint.message" @close="closeHint"></hint>
  </div> 
</template>

<script>
// require styles
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import API from '../../api/api';
import WaterMark from './waterMark';
import constant from '../../constant';

// Similarly, you can also introduce the plugin resource pack you want to use within the component
// import 'some-videojs-plugin'
export default {
  components: {
    videoPlayer,
  },
  data() {
    return {
      playerOptions: {
        aspectRatio: "16:9",
        fluid: true,
        autoplay: true,
        preload: 'auto',
        // videojs options
        muted: false,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: ""
        }],
        volumeMenuButton: {
          inline: true,//设置音量bar为竖直
          vertical: true//设置音量bar为竖直
        },
        controlBar: {
          'currentTimeDisplay':true,
          'timeDivider':true,
          'durationDisplay':true,
          'remainingTimeDisplay':true,
          'fullscreenToggle': false,
          volumePanel: {
            inline: false,
          }
        },
        flash: { hls: { withCredentials: false }},
        html5: { hls: { withCredentials: false }},
        notSupportedMessage: "此影片暫時無法播放，請稍後再試", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      },
      fullscreentitle: "全螢幕",
      loading: false,
      getDataOk: false,
      infoId: '',
      fileId: '',
      //跳出hint
      hint: {
        message: '',
        display: false,
      },
      timer: null,
      inputText : "",
      systemAdminMode : "",
      fullscreen: false,
      myVideo: null,
      loaded: false,
    }
  },
  beforeDestroy: function() {
    /*
    if(this.$store.state.isBackendMode === false) {
			document.getElementsByClassName('main')[0].removeChild(document.getElementById('_waterMark'));	
    }
    */

    if(this.loaded) {
      this.$store.state.closeTime = Math.floor(Date.now() / 1000);
      API.setResourceWatchTime(this.infoId, this.fileId, Math.abs(this.$store.state.closeTime - this.$store.state.openTime)).then((response) => {
        if(response.status) {
          redirectLogin(response.data);
          if(!JSON.parse(response.request.response).error_msg) {
						this.showHint('設定時間錯誤!');
					} else {
						this.showHint(JSON.parse(response.request.response).error_msg);	
					}
        } else {
          
        }
      });
    }

    if (this.player) {
      //this.player = null;
      delete this.player;
    }

    this.loaded = false;
  },
  destroyed:function() {
    window.removeEventListener('beforeunload', e => this.beforeunloadFn(e));
  },
  mounted() {
    API.getUser().then((result) => {
      if(result.status) {
        redirectLogin(result.data);
        if(!JSON.parse(result.request.response).error_msg) {
          this.showHint('取得使用者資訊錯誤!');
        } else {
          this.showHint(JSON.parse(result.request.response).error_msg);
        }
      } else {
        //update username
        this.$store.state.userName = result.name;
        this.inputText = 'Confidential for ' + this.$store.state.userName;
        API.accountInfo(this.$store.state.userName).then((response) => {
          if(response.status !== 0 && response.status !== 1) {
            redirectLogin(response.data);
          } else {
            if(response.isManager === 2) {
              this.$store.state.isSystemAdminMode = true;
              this.$store.state.isBackendMode = true;
            } else if(response.isManager === 1) {
              this.$store.state.isSystemAdminMode = false;
              this.$store.state.isBackendMode = true;
            } else {
              this.$store.state.isSystemAdminMode = false;
              this.$store.state.isBackendMode = false;
            }
            this.systemAdminMode = this.$store.state.isSystemAdminMode;
          }
          this.getVideo();
        });	
      }
    });
  },
  created() {
    document.addEventListener('fullscreenchange', this.exitHandler);
    document.addEventListener('webkitfullscreenchange', this.exitHandler);
    document.addEventListener('mozfullscreenchange', this.exitHandler);
    document.addEventListener('MSFullscreenChange', this.exitHandler);
    this.$store.state.nowStatus = 6;
    this.loading = true;
    this.$store.state.openTime = 0;
    this.$store.state.closeTime = 0;
    this.infoId = Number(location.hash.split('/')[2].split('&')[0]);
    this.fileId = String(location.hash.split('/')[2].split('&')[1]);
    window.addEventListener('beforeunload', e => this.beforeunloadFn(e));
  },
  computed: {
    player() {
      if(this.$store.state.nowStatus === 6 && this.getDataOk) {
        return this.$refs.videoPlayer.player;
      }
    }
  },
  methods: {
    getVideo() {
      let self = this;
      // assign access_token and site_code
      //取得影片串流播放網址
      API.getVideoStream(self.infoId, self.fileId, 'videopreview').then((response) => {
        if(response.status !== 200) {  
          redirectLogin(response.data);
          self.loading = false; 
          if(!JSON.parse(response.request.response).error_msg) {
            self.showHint('取得影片檔案錯誤!');
          } else {
            self.showHint(JSON.parse(response.request.response).error_msg);	
          }
        } else {
          this.getDataOk = true;
          /*
          var xhr = new XMLHttpRequest();
          xhr.open("GET", constant.apiUrl + '/api/science/resources/download/' + self.infoId + '/' + self.fileId + '/videopreview');
          xhr.setRequestHeader('Authorization', 'Bearer ' + ACCESS_TOKEN);
          xhr.setRequestHeader('X-science-site-code', 'semibookclub');
          xhr.onload = function () {
            self.playerOptions.sources[0].src = this.responseURL;
          }
          xhr.send('string');
          */
          /*
          videojs.xhr({
            //body: someJSONString,
            uri: constant.apiUrl + '/api/science/resources/download/' + self.infoId + '/' + self.fileId + '/videopreview',
            headers: {
              'Authorization' : 'Bearer ' + ACCESS_TOKEN,
              'X-science-site-code' : 'semibookclub'
            }
          }, function (err, resp, body) {
            console.log(resp);
            //self.playerOptions.sources[0].src = resp.rawRequest.responseURL;
            self.playerOptions.sources[0].src = this.uri;
            console.log(self.playerOptions.sources[0].src);
            //self.playerOptions.sources[0].src = constant.apiUrl + '/api/science/resources/download/' + self.infoId + '/' + self.fileId + '/videopreview';
          });
          */
          self.loading = false; 
          //先讓firefox用mp4播但會沒聲音, 因為scloud目前沒有轉檔ogv
          self.playerOptions.sources[0].src = response.data.videoPreviewURL.mp4;

          /*
          if (!navigator.userAgent.match('Chrome')) {
            self.playerOptions.sources[0].src = response.data.videoPreviewURL.ogv;
          } else {
            self.playerOptions.sources[0].src = response.data.videoPreviewURL.mp4;
          }
          */
          //check video fit div for width or height
          self.playerOptions.height = document.getElementsByClassName('content-container')[0].clientHeight - 30;
          self.playerOptions.width = window.innerWidth - 30;
          //Disable Video Player right menu
          this.myVideo = document.getElementById("videovuer");
            
          if (this.myVideo.addEventListener) {
            this.myVideo.addEventListener('contextmenu', function(e) {
              e.preventDefault();
            }, false);
          } else {
            this.myVideo.attachEvent('oncontextmenu', function() {
              window.event.returnValue = false;
            });
          } 
        }
      });
    },
    // listen event
    onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    onPlayerEnded(player) {
      // console.log('player ended!', player)
    },
    onPlayerLoadeddata(player) {
      //console.log('player Loadeddata!', player)
    },
    onPlayerWaiting(player) {
      // console.log('player Waiting!', player)
    },
    onPlayerPlaying(player) {
      // console.log('player Playing!', player)
    },
    onPlayerTimeupdate(player) {
      //console.log('player Timeupdate!', player.currentTime())
    },
    onPlayerCanplay(player) {
      if(!this.loaded) {
        this.$store.state.openTime = Math.floor(Date.now() / 1000);
      }
      this.loaded = true;
      //console.log('player Canplay!', player)
    },
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    },
    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },  
    // player is ready
    playerReadied(player) {
      console.log('player readied', player);
    },
    /**
    * closeHint close hint 視窗
    * @return none
    */
    closeHint: function() {
      this.hint.display = false;
      this.$store.state.hintStatus.videoView = false;
      clearTimeout(this.timer);
    },
    /**
    * showHint 
    * @param  {string} message - message
    * @return none
    */
    showHint: function(message) {
      if(this.timer) {
				clearTimeout(this.timer);	
			}
      this.hint.display = true;
      this.hint.message = message;	
      this.$store.state.showHint = true;
      this.$store.state.hintStatus.videoView = true;
      this.timer = setTimeout(()=>{
        if(this.$store.state.showHint) {
            this.$store.state.showHint = false;
            this.$store.state.hintStatus.videoView = false;
        }
      }, this.$store.state.fadeOutTime);
    },
    toggle: function() {
      this.fullscreen = !this.fullscreen;
      if (this.fullscreen) {
        this.openFullscreen(document.getElementsByClassName('main')[0])
      } else {
        this.closeFullscreen();
      } 
    },
    openFullscreen: function(document) {
      this.myVideo.style.maxWidth = "none";
      if (document.requestFullscreen) {
        document.requestFullscreen();
      } else if (document.mozRequestFullScreen) { /* Firefox */
        document.mozRequestFullScreen();
      } else if (document.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        document.webkitRequestFullscreen();
      } else if (document.msRequestFullscreen) { /* IE/Edge */
        document.msRequestFullscreen();
      }
      this.fullscreentitle = "離開全螢幕";
    },
    closeFullscreen: function() {
      this.myVideo.style.maxWidth = "1440px";
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
      }
      this.fullscreentitle = "全螢幕";
    },
    exitHandler: function() {
      if(!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
        this.myVideo.style.maxWidth = "1440px";
        this.fullscreen = false;
        this.fullscreentitle = "全螢幕";
      }
    },
    beforeunloadFn(e) {
      if(this.loaded) {
        this.$store.state.closeTime = Math.floor(Date.now() / 1000);
        let logData = {
          'watchtime': Math.abs(this.$store.state.closeTime - this.$store.state.openTime)
        };
        let headers = {
          type: 'application/json',
          Authorization : 'Bearer ' + foxdrive_api.getCookie('access_token'),
        };
        let blob = new Blob([JSON.stringify(logData)], headers);
        let result = navigator.sendBeacon(constant.apiUrl + '/api/science/resources/watchtime/' + this.infoId + '/' + this.fileId, blob);
        if (result) { 
          console.log('請求成功排隊等待執行');
        } else {
          console.log('失敗');
        }
      }  
      this.loaded = false;  
    },
  }
}
</script>

<style lang="css">
  .loading-icon {
		height: 60px !important;
		width: 60px !important;
    margin-top: 20%;
    background-color: #1D2327 !important;
	}	
  .video-js {
    display: inline-block;
    margin: 0 auto;
  }
  .fullscreen-btn {
    position: fixed;
    z-index: 1;
    display: block;
    margin: 5px 5px;
    background-color: RGBA(255, 255, 255, 0.4);
    border-color: RGBA(255, 255, 255, 0.4);
    width: 60px !important;
    height: 60px !important;
  }
  .fullscreen-btn:focus {
    border: none !important;
    outline: none !important;
  }
  .fullscreen-icon {
    margin: -5px -5px;
    display: inline-block;
    vertical-align: middle;
    width: 36px !important;
    height: 36px !important;
	}	
</style>


// WEBPACK FOOTER //
// Video.vue?8b07476a